import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Card, CardContent, Grid, Button } from "@mui/material";
import "./Franchise.css";
import { useThemeContext } from "../../Context/ThemeContext.js";
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from "../../Utils/constants.js";
import ArrowButton from "../../Components/Common/ArrowButton.js";
import { getFranchises } from "../../Services/authService.js";
import LoadingAnimation from "../../Components/Common/LoadingAnimation.js";
import tempLogo from "../../assets/Group.webp";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { useNavigate } from "react-router-dom";

function Franchise() {
  const navigate = useNavigate();
  const { mode } = useThemeContext();
  const { t } = useTranslation();

  const containerBackground =
    mode === "dark" ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const textColor =
    mode === "dark"
      ? DARKCOLORS.BodyLightBackground
      : LIGHTCOLORS.BodyLightBackground;
  const cardtitlesdivs =
    mode === "light" ? LIGHTCOLORS.GreyScale10 : DARKCOLORS.GreyScale10;
  const colorWarning =
    mode === "dark" ? DARKCOLORS.Warning500 : LIGHTCOLORS.Warning500;
  const colorWarning1 =
    mode === "dark" ? DARKCOLORS.Warning100 : LIGHTCOLORS.Warning100;
  const colorSuccess =
    mode === "dark" ? DARKCOLORS.Secondary500 : LIGHTCOLORS.Secondary500;
  const colorSuccess1 =
    mode === "dark" ? DARKCOLORS.Secondary100 : LIGHTCOLORS.Secondary100;
  //const textColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const btnborderColor =
    mode === "dark" ? DARKCOLORS.GreyScale50 : LIGHTCOLORS.GreyScale50;

  const [loading, setLoading] = useState(false);
  const [franchiseData, setFranchiseData] = useState(null);

  useEffect(() => {
    const fetchFranchises = async () => {
      try {
        setLoading(true);
        const response = await getFranchises();



setFranchiseData(response);
      } catch (err) {
        console.log(t("franchise.errorLoadingFranchiseData"));
      } finally {
        setLoading(false);
      }
    };
    fetchFranchises();
  }, []);

  const getStatusDotStyles = (isActive) => {
    if (isActive) {
      return {
        backgroundColor: colorSuccess,
        border: `3px solid ${colorSuccess1}`,
      };
    }
    return {
      backgroundColor: colorWarning,
      border: `3px solid ${colorWarning1}`,
    };
  };

  const handleViewMore = (id) => {
    navigate(ROUTES.ADDFRANCHISE, {
      state: {
        mode: "update", // Specify the mode
        id, // Pass the existing machine data
      },
    });
  };
  return (
    <div className="dashboard-container-overview">
      {loading && <LoadingAnimation />}
      <Box
        className="franchise-container-overview"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 className="membership-text-heading">
          {t("franchise.franchiseManagement")}
        </h2>

        <Box
          className="franchise-button-container"
          sx={{ display: "flex", gap: 1, marginBottom: "15px" }}
        >
          {/* <Button
            // id='service-request-button'
            sx={{
              borderRadius: "40px",
              gap: 1.5,
              padding: "11px 20px",
              border: `1px solid ${btnborderColor}`,
              color: textColor,
              textTransform: "none",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
            id="transactions-button"
            onClick={() => navigate("/payout")}
            endIcon={<ReceiptLongOutlinedIcon />}
          >
            {t("franchise.payout")}
          </Button> */}

          <Button
            id="service-request-button"
            className="export-sales-btn"
            onClick={() => navigate(ROUTES.ADDFRANCHISE)}
            endIcon={<AddCircleOutlineOutlinedIcon />}
          >
            {t("franchise.addFranchise")}
          </Button>
        </Box>
      </Box>
      <Grid container spacing={3} sx={{ marginTop: "1px", mb: 6 }}>
        {franchiseData?.map((card, index) => (
          <Grid
            className="grid-item"
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              sx={{
                width: "100%",
                maxWidth: "100%",
                p: 1,
                borderRadius: "12px",
                backgroundColor: containerBackground,
                boxShadow: "none",
              }}
            >
              <CardContent>
                <Grid container>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        <img
                          src={card.logoUrl ? card.logoUrl : tempLogo}
                          alt={`${card.name} logo`}
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <p
                            id="machineStreet"
                            className="machine-name-text"
                            style={{
                              maxWidth: "100%",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textWrap: "nowrap",
                              margin: 0,
                            }}
                          >
                            {card.name}
                          </p>
                          <p
                            className="add-machine"
                            id="machineStreet"
                            style={{ color: textColor, margin: "0px" }}
                          >
                            {card.city}
                          </p>
                        </Box>
                      </Box>
                      <Box
                        sx={{ flexShrink: 0, ml: 2 }}
                        onClick={() => handleViewMore(card.id)}
                      >
                        <ArrowButton />
                      </Box>
                    </Box>
                    <Box sx={{ mt: 3 }}>
                      {/* Status */}
                      {/* <Box
                        sx={{
                          borderRadius: "8px",
                          padding: "15px 14px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "0.5rem",
                          border: `1px solid ${cardtitlesdivs}`,
                        }}
                      >
                        <p className="label-text-sec" style={{ margin: "0px" }}>
                          {t("dashboard.status")}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            justifyContent: "flex-start",
                            width: "35%",
                          }}
                        >
                          <span
                            style={{
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              ...getStatusDotStyles(card.active),
                            }}
                          />
                          <p
                            className="add-machine"
                            id="machineStreet"
                            style={{ color: textColor, margin: "0px" }}
                          >
                            {card.active ? "Active" : "Inactive"}
                          </p>
                        </Box>
                      </Box> */}

                      {/* No.of Machines */}
                      <Box
                        sx={{
                          backgroundColor: cardtitlesdivs,
                          border: `1px solid ${cardtitlesdivs}`,
                          borderRadius: "8px",
                          padding: "15px 14px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p className="label-text-sec" style={{ margin: "0px" }}>
                          {t("franchise.no.ofMachines")}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            justifyContent: "flex-start",
                            width: "35%",
                          }}
                        >
                          <p
                            className="add-machine"
                            id="machineStreet"
                            style={{ color: textColor, margin: "0px" }}
                          >
                            {card.numberOfMachinesOwned}
                          </p>
                        </Box>
                      </Box>

                      {/* Email */}
                      <Box
                        sx={{
                          borderRadius: "8px",
                          padding: "14px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "0.5rem",
                          border: `1px solid ${cardtitlesdivs}`,
                        }}
                      >
                        <p className="label-text-sec" style={{ margin: "0px" }}>
                          {t("franchise.email")}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            justifyContent: "flex-start",
                            width: "35%",
                          }}
                        >
                          <p
                            className="add-machine"
                            id="machineStreet"
                            style={{ color: textColor, margin: "0px" }}
                          >
                            {card.email}
                          </p>
                        </Box>
                      </Box>

                      {/* Phone Number */}
                      <Box
                        sx={{
                          backgroundColor: cardtitlesdivs,
                          border: `1px solid ${cardtitlesdivs}`,
                          borderRadius: "8px",
                          padding: "15px 14px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p className="label-text-sec" style={{ margin: "0px" }}>
                          {t("franchise.phoneNumber")}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            justifyContent: "flex-start",
                            width: "35%",
                          }}
                        >
                          <p
                            className="add-machine"
                            id="machineStreet"
                            style={{ color: textColor, margin: "0px" }}
                          >
                            {card.phoneNumber}
                          </p>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Franchise;
